module.exports = __webpack_public_path__ + "img/youtube-square.1ab3c0ca.svg";